import { STATE_NAMES } from 'STATES';

export const getPlaceDetails = ({ query }: any) => {
  let splitArr = query?.q?.split('--');
  const shortStateName = splitArr?.[1].toUpperCase();
  const place = splitArr?.[0];
  const isCity = place.match(/[a-zA-Z]/);

  const longStateName = STATE_NAMES[shortStateName.toUpperCase() as keyof typeof STATE_NAMES];
  const locationWithLongState = `${place}, ${longStateName}`;
  const locationWithShortState = `${place}, ${shortStateName}`;

  return {
    locationWithShortState,
    locationWithLongState,
    isCity,
    place,
    shortStateName,
    longStateName,
  };
};
